<proffeo-ui-page-wrapper>
  <div class="w-full pt-3 lg:pt-6">
    <div
      [proffeoSpinner]="companies() === undefined || !currentProjectParticipants()"
      proffeoSpinnerSize="lg"
      class="flex min-h-48 w-full flex-col rounded-md border border-proffeo-border bg-proffeo-surface"
    >
      @if (companies()?.length > 0) {
        @for (company of companies(); track company.id) {
          <proffeo-project-participants-for-company
            [company]="company"
            [participants]="participantsForCompany(company)()"
          ></proffeo-project-participants-for-company>
        }
      } @else if (companies()) {
        <div class="flex w-full items-center justify-center p-4">
          <p>{{ 'placeholders.no-results-found' | translate }}</p>
        </div>
      }
    </div>
  </div>
</proffeo-ui-page-wrapper>
